import { IPatient } from '@alberta/konexi-shared';
import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PatientDB } from 'src/app/common/repository/databases';
import { QueryService } from 'src/app/shared/services/query/query.service';

interface ISelectedPatient {
  patient: IPatient;
  selected: boolean;
}

@Component({
  selector: 'activity-patient-search',
  templateUrl: './activity-patient-search.component.html',
  styleUrls: ['activity-patient-search.component.scss'],
})
export class ActivityPatientSearchComponent implements OnInit {
  @Input()
  public institutionId: string;
  @Input()
  public institutionSearchField: string;
  @Input() patientIds: string[];
  public selectedPatients: IPatient[] = [];
  public selectedItems: ISelectedPatient[] = [];
  public hasSearched = false;

  get allSelected(): boolean {
    return this.selectedItems.every(item => item.selected);
  }

  get toggleCheckboxText(): string {
    if (this.allSelected) {
      return 'Alle abwählen';
    } else {
      return 'Alle anwählen';
    }
  }

  constructor(
    private _queryService: QueryService,
    private _modalController: ModalController
  ) {}
  async ngOnInit() {
    const patients = await this._queryService.search<IPatient>(
      { query: `${this.institutionSearchField}:${this.institutionId}` },
      PatientDB
    );
    this.selectedItems = patients.sort(this.patientSort).map(patient => {
      const isSelected = this.patientIds.includes(patient._id);
      return { patient, selected: isSelected };
    });
    this.selectedPatients = this.selectedItems.filter(item => item.selected).map(item => item.patient);
  }

  public async done() {
    await this._modalController.dismiss(this.selectedPatients, undefined, 'ActivityPatientSearchComponent');
  }

  async cancel() {
    await this._modalController.dismiss(undefined, 'canceled', 'ActivityPatientSearchComponent');
  }

  public selectionChanged(item: ISelectedPatient) {
    item.selected = !item.selected;
    if (item.selected && !this.selectedPatients.some(patient => patient._id === item.patient._id)) {
      this.selectedPatients.push(item.patient);
    } else if (!item.selected && this.selectedPatients.some(patient => patient._id === item.patient._id)) {
      this.selectedPatients = this.selectedPatients.filter(patient => patient._id !== item.patient._id);
    }
  }

  public dismissSelection(patient: IPatient) {
    const selectedItem = this.selectedItems.find(item => item.patient._id === patient._id);
    this.selectionChanged(selectedItem || { patient, selected: false });
  }

  public async reset(): Promise<void> {
    await this.search('***');
  }

  public async search(searchTerm: string): Promise<void> {
    this.hasSearched = false;
    let query = this.stripSpaces(searchTerm);
    query = `${searchTerm === '***' ? '' : query} ${
      searchTerm === '***' || searchTerm === '' ? `${this.institutionSearchField}:` : ''
    }${this.institutionId}`.trim();
    const foundPatients = await this._queryService.search<IPatient>({ query }, PatientDB, { isIn: false });
    this.selectedItems = foundPatients.map(patient => {
      const isSelected = this.selectedPatients.some(selectedPatient => selectedPatient._id === patient._id);
      return { patient, selected: isSelected };
    });
    this.hasSearched = true;
  }

  public toggleAllChecked($event?: Event): void {
    if ($event) {
      $event.stopPropagation();
    }
    if (this.selectedItems.every(item => item.selected)) {
      this.selectedItems.map(item => (item.selected = false));
    } else {
      this.selectedItems.map(item => (item.selected = true));
    }
  }

  private stripSpaces(searchTerm: string): string {
    return searchTerm.replace(/\s{2,}/g, ' ').trim();
  }

  private patientSort(a: IPatient, b: IPatient): 1 | -1 | 0 {
    return a.firstName > b.firstName ? 1 : a.firstName < b.firstName ? -1 : 0;
  }
}
